import { Factory } from '../../services/Factory';

namespace app.directives.controls {
  import IAugmentedJQuery = angular.IAugmentedJQuery;

  export interface IThumbnailScope extends angular.IScope {
    trustedUrl: string,
    src: string
  }

  export interface IThumbnailAttributes extends angular.IAttributes {
  }

  export class Thumbnail implements angular.IDirective {
    public restrict: string = "E";
    public link: (scope: IThumbnailScope, element: IAugmentedJQuery, attrs: IThumbnailAttributes) => void;
    public template = `<div><iframe width="75" height="100" src="{{trustedUrl}}" frameborder="0" scrolling="no" allowfullscreen style="-webkit-transform:scale(0.5);-moz-transform-scale(0.5);"></iframe></div>`;
    public scope = {src: '@'};

    constructor($sce) {
      this.link = (scope: IThumbnailScope) => {
        scope.trustedUrl = $sce.trustAsResourceUrl(scope.src);
      }
    }
  }

  frontendApp.directive("iioThumbnail", ["$sce", Factory.Create(Thumbnail)]);
}
